import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { DiamondMark, Wordmark } from "./Brand";
import { scrollToId } from "./SmoothScroll";
import { SOCIALS } from "../data/products";

export const Navbar = () => (
  <motion.header
    initial={{ y: -30, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed top-0 inset-x-0 z-50 border-b border-white/5 bg-[#09040E]/70 backdrop-blur-xl"
    data-testid="site-navbar"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
      <a href="/" className="flex items-center gap-2.5" data-testid="nav-logo-link">
        <DiamondMark className="w-4 h-4" />
        <Wordmark className="text-lg sm:text-xl" />
      </a>
      <div className="flex items-center gap-2 sm:gap-6">
        <button onClick={() => scrollToId("suppliers")} className="hidden sm:block text-xs tracking-[0.25em] uppercase text-violet-200 hover:text-gold transition-colors" data-testid="nav-suppliers-link">Suppliers</button>
        <button onClick={() => scrollToId("how")} className="hidden sm:block text-xs tracking-[0.25em] uppercase text-violet-200 hover:text-gold transition-colors" data-testid="nav-how-link">How it works</button>
        <a href={SOCIALS.instagram.url} target="_blank" rel="noreferrer" aria-label="Instagram" className="p-2 text-violet-200 hover:text-gold transition-colors" data-testid="nav-instagram-link"><Instagram className="w-4 h-4" /></a>
        <button onClick={() => scrollToId("suppliers")} className="btn-gold text-[11px] px-4 py-2.5" data-testid="nav-get-access-btn">Get access</button>
      </div>
    </div>
  </motion.header>
);
